import {
  ConditionDTO,
  ImportIngredientsDTO,
  IngredientConflictDto,
  IngredientImportConflictType,
  VendorDTO,
} from 'business/models/Models';
import {
  getConflictedIngredientsList,
  SaveImportedIngredients,
} from 'business/services/IngredientService';
import React, { useCallback, useEffect, useState } from 'react';
import { readFileAsBase64String, getNewId, showSnackBar } from 'utils/Global';
import { IngredientsConflictsModel } from './IngredientsConflictsModel';
import { setIngTableDataIndicator } from 'redux/reducers/ingredientTableReducer';
import { useRMDispatch, useRMSelector } from 'redux/hooks';
import { LoadingModal } from 'components/modal';
export interface IngredientsImportsProps {
  modelRef: any;
  importedIngredients?: ImportIngredientsDTO;
  setResolvedIngredients?: (value: ImportIngredientsDTO) => void;
  isScreen?: boolean;
  conditions?: ConditionDTO[];
  setConditions?: (value: ConditionDTO[]) => void;
  hasAdditionalStock?: boolean;
}
export const IngredientsImportManager = (props: IngredientsImportsProps) => {
  const {
    modelRef,
    importedIngredients,
    setResolvedIngredients,
    isScreen,
    conditions,
    setConditions,
    hasAdditionalStock,
  } = props;
  const [showModal, setShowModal] = useState<boolean>(false);
  const [nonConflictedIng, setNonConflictedIng] = useState<IngredientConflictDto[]>([]);
  const [conflictedIng, setConflictedIng] = useState<IngredientConflictDto[]>([]);
  const [resolvedIng, setResolvedIng] = useState<IngredientConflictDto[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [vendors, setVendors] = useState<VendorDTO[]>([]);
  const [incomingIngredientList, setIncomingIngredientList] =
    useState<ImportIngredientsDTO>(importedIngredients);
  const dispatch = useRMDispatch();
  const ingTableDataIndicator = useRMSelector(
    (state) => state.ingredientsTable.ingTableDataIndicator,
  );

  useEffect(() => {
    modelRef.current = () => {
      importData();
    };
  }, [modelRef]);

  useEffect(() => {
    if (incomingIngredientList?.conflictIngredientsList.length > 0) {
      setNonConflictedIng(incomingIngredientList.nonConflictIngredientsList);
      incomingIngredientList.conflictIngredientsList = setCasNumberIds(
        incomingIngredientList.conflictIngredientsList,
      );
      if (
        incomingIngredientList.conflictIngredientsList.some(
          (ing) => ing.conflictType === IngredientImportConflictType.NoMatch,
        )
      ) {
        incomingIngredientList.conflictIngredientsList.map((ing) => {
          if (ing.conflictType === IngredientImportConflictType.NoMatch) {
            ing.matchingIngredients = incomingIngredientList.ingredients;
          }
        });
      }
      setConflictedIng(incomingIngredientList.conflictIngredientsList);
      if (vendors?.length === 0) {
        const vendor = new VendorDTO({ id: -1, name: 'Select Stock' });
        incomingIngredientList.vendorsList.unshift(vendor);
        setVendors(incomingIngredientList.vendorsList);
      }
      setShowModal(true);
    } else if (
      setResolvedIngredients &&
      incomingIngredientList?.nonConflictIngredientsList.length > 0
    ) {
      setResolvedIngredients(incomingIngredientList);
    }
  }, [incomingIngredientList]);

  useEffect(() => {
    setIncomingIngredientList(importedIngredients);
  }, [importedIngredients]);

  const fileChangedHandler = async (e) => {
    const file = e.target.files[0];

    await readFileAsBase64String(file, searchConflicts);
  };
  const setCasNumberIds = (conflictedIngredients: IngredientConflictDto[]) => {
    return conflictedIngredients.map((ingredients) => {
      ingredients?.xmlImportIngredient?.casnumbers.map(
        (casnumber) => (casnumber.id = getNewId()),
      );
      return ingredients;
    });
  };
  const searchConflicts = async (response) => {
    setIsLoading(true);
    const list = await getConflictedIngredientsList(response);
    if (
      list.nonConflictIngredientsList.length > 0 ||
      list.conflictIngredientsList.length > 0
    ) {
      setIncomingIngredientList(list);
    }
    setIsLoading(false);
  };
  const importData = useCallback(() => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.xml';
    input.oninput = fileChangedHandler;
    input.click();
  }, []);
  const saveIngredients = async () => {
    const incomingIngredients = new ImportIngredientsDTO();
    incomingIngredients.conflictIngredientsList = conflictedIng;
    incomingIngredients.nonConflictIngredientsList = nonConflictedIng;
    if (setResolvedIngredients) {
      setResolvedIngredients(incomingIngredients);
    } else {
      const resp = await SaveImportedIngredients(incomingIngredients);
      if (resp === true) {
        showSnackBar('Ingredients Imported Successfully.');
        setShowModal(false);
        if (!isScreen) {
          dispatch(setIngTableDataIndicator(ingTableDataIndicator + 1));
        }
      } else {
        showSnackBar('Ingredients Import Failed.');
      }
    }
    setShowModal(false);
  };

  return (
    <>
      <LoadingModal showModal={isLoading} text={'Please Wait.'} />
      {showModal && (
        <IngredientsConflictsModel
          showModal={showModal}
          setShowModal={setShowModal}
          nonConflictIngredientsList={nonConflictedIng}
          conflictIngredientsList={conflictedIng}
          setNonConflictIngredientsList={setNonConflictedIng}
          setConflictIngredientsList={setConflictedIng}
          setResolvedIngredientsList={setResolvedIng}
          resolvedIngredientsList={resolvedIng}
          vendors={vendors}
          saveIngredients={saveIngredients}
          isScreen={isScreen}
          conditions={conditions}
          setConditions={setConditions}
          hasAdditionalStock={hasAdditionalStock}
        />
      )}
    </>
  );
};
